export default Alpine => {
  let hash = Alpine.reactive({
    name: decodeURIComponent(location.hash.slice(1)),
  })

  window.addEventListener('hashchange', () => {
    hash.name = decodeURIComponent(location.hash.slice(1))
  })

  Alpine.magic('hash', () => hash.name)
}
